import { render, staticRenderFns } from "./ForwardDialogComponent.vue?vue&type=template&id=70590591&scoped=true"
import script from "./ForwardDialogComponent.js?vue&type=script&lang=js&external"
export * from "./ForwardDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./ForwardDialogComponent.vue?vue&type=style&index=0&id=70590591&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70590591",
  null
  
)

export default component.exports